/* ============================================================
   99TIMORO Main JS — Global helpers + Swiper init
   (cartDrawer Alpine component is registered in theme.liquid inline script)
   ============================================================ */

/* ── Global addToCart ── */
async function addToCart(variantId, quantity = 1, btn = null) {
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (res.ok) {
      window.dispatchEvent(new CustomEvent('open-cart'));
    }
  } catch (e) {
    console.error('addToCart error', e);
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
  }
}

/* ── Swiper init ── */
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.prod-swiper')) {
    new Swiper('.prod-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      pagination: { el: '.prod-swiper .swiper-pagination', clickable: true }
    });
  }
  if (document.querySelector('.fp-swiper')) {
    new Swiper('.fp-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      pagination: { el: '.fp-swiper .swiper-pagination', clickable: true }
    });
  }
  if (document.querySelector('.review-swiper')) {
    new Swiper('.review-swiper', {
      slidesPerView: 1.1,
      spaceBetween: 16,
      pagination: { el: '.review-swiper .swiper-pagination', clickable: true },
      breakpoints: { 768: { slidesPerView: 3, spaceBetween: 20 } }
    });
  }
});

/* ── Product card: swatch click → swap variant image ──
   Class names must stay in step with snippets/card-product.liquid. They were
   .pc__swatch / .pc / .pc__img before the v1 card redesign; if the markup is
   renamed again and this is not, the swap silently stops working and nothing
   reports an error. */
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.elu-swatch[data-img]');
  if (!swatch) return;

  const card = swatch.closest('.elu-card');
  if (!card) return;

  const img = card.querySelector('.elu-card__img:not(.elu-card__img--alt):not(.elu-card__img--ph)');
  if (!img) return;

  const newSrc = swatch.dataset.img;
  if (!newSrc) return;

  // Swap src + regenerate srcset using Shopify CDN width param
  img.src = newSrc;
  img.srcset = [
    newSrc.replace(/width=d+/, 'width=300') + ' 300w',
    newSrc.replace(/width=d+/, 'width=500') + ' 500w',
    newSrc.replace(/width=d+/, 'width=700') + ' 700w',
  ].join(', ');

  // Update active state. aria-pressed as well as the class, because the
  // swatches are real buttons now rather than spans.
  card.querySelectorAll('.elu-swatch').forEach(function (s) {
    s.classList.remove('is-active');
    s.setAttribute('aria-pressed', 'false');
  });
  swatch.classList.add('is-active');
  swatch.setAttribute('aria-pressed', 'true');
});

/* ── Product card: wishlist ──
   localStorage only, so it holds on this browser and nowhere else: no account
   sync, no saved-items page. Anything that promises more than that is a lie.

   Reads and writes are wrapped because localStorage throws outright in a
   private window with site data blocked, and a card that cannot remember a
   heart should still render. */
(function () {
  const KEY = 'elu:wishlist';

  const read = function () {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  };

  const write = function (ids) {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) { /* ignore */ }
  };

  const paint = function () {
    const ids = read();
    document.querySelectorAll('[data-elu-wish]').forEach(function (btn) {
      const on = ids.indexOf(btn.dataset.eluWish) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-elu-wish]');
    if (!btn) return;
    e.preventDefault();

    const id = btn.dataset.eluWish;
    const ids = read();
    const at = ids.indexOf(id);
    if (at === -1) ids.push(id); else ids.splice(at, 1);
    write(ids);
    paint();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
